import React from 'react';

const Error = ({ message = 'Vérifiez votre identifiant ou mot de passe' }) => (
  <div className="account-error">
    {message}
  </div>
);

export default Error;
